export default class LinkList {
	constructor() {
		this.$list = $('.js-link-list');
		this.$li = this.$list.find('> li > a');
		this.activeClass = 'js-is-active';
	}

	onClick(event) {
		const $elm = $(event.currentTarget);
		const $ul = $elm.parent().find('ul');

		$elm.toggleClass(this.activeClass);
		$ul.slideToggle(300);

		return false;
	}

	setEventBindings() {
		this.$li.on('click', this.onClick.bind(this));
	}

	init() {
		this.setEventBindings();
	}
}


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/components/LinkList.js